import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=104798cb&"
var script = {}
import style0 from "./Confirmation.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports